import { isAfter, isBefore, isValid as isValidDate, isWithinInterval, subDays, subMonths, subYears } from 'date-fns';

import { formatDate, formatLocaleDate, todayDate } from './date-formatter';

const toServerDateValue = (date: Date) => formatLocaleDate(date);

const LAST_7_DAYS_VALUE = toServerDateValue(subDays(todayDate(), 7));
const LAST_30_DAYS_VALUE = toServerDateValue(subDays(todayDate(), 30));
const LAST_3_MONTHS_VALUE = toServerDateValue(subMonths(todayDate(), 3));
const LAST_YEAR_VALUE = toServerDateValue(subYears(todayDate(), 1));
export const TODAY_DATE_VALUE = toServerDateValue(todayDate());

const LAST_7_DAYS_LABEL = 'Last 7 Days';
const LAST_30_DAYS_LABEL = 'Last 30 Days';
const LAST_3_MONTHS_LABEL = 'Last 3 Months';
const LAST_YEAR_LABEL = 'Last Year';

export const dateRangeOptions = [
    { value: LAST_7_DAYS_VALUE, label: LAST_7_DAYS_LABEL },
    { value: LAST_30_DAYS_VALUE, label: LAST_30_DAYS_LABEL },
    { value: LAST_3_MONTHS_VALUE, label: LAST_3_MONTHS_LABEL },
    { value: LAST_YEAR_VALUE, label: LAST_YEAR_LABEL },
];

export const getDateRangeLabel = (prefix: string, startDate: string | null, endDate: string | null): string => {
    if (startDate && endDate) {
        if (endDate === TODAY_DATE_VALUE) {
            if (startDate === LAST_7_DAYS_VALUE) return `${prefix}: ${LAST_7_DAYS_LABEL}`;
            if (startDate === LAST_30_DAYS_VALUE) return `${prefix}: ${LAST_30_DAYS_LABEL}`;
            if (startDate === LAST_3_MONTHS_VALUE) return `${prefix}: ${LAST_3_MONTHS_LABEL}`;
            if (startDate === LAST_YEAR_VALUE) return `${prefix}: ${LAST_YEAR_LABEL}`;
        }
        return `${prefix}: ${formatDate(startDate)} - ${formatDate(endDate)}`;
    }
    if (startDate) {
        return `${prefix}: After ${formatDate(startDate)}`;
    }
    if (endDate) {
        return `${prefix}: Before ${formatDate(endDate)} `;
    }

    return prefix;
};

export const filterByDateRange = (
    dateString: string,
    startDateString: string | null,
    endDateString: string | null,
): boolean => {
    const date = new Date(dateString);
    const isDateValid = isValidDate(date);
    if (!isDateValid) return false;

    const start = new Date(startDateString || '');
    const isStartValid = isValidDate(start);
    const end = new Date(endDateString || '');
    const isEndValid = isValidDate(end);
    if (isStartValid && isEndValid) {
        return isWithinInterval(date, {
            start,
            end,
        });
    }

    if (isStartValid) {
        return isAfter(date, start);
    }

    if (isEndValid) {
        return isBefore(date, end);
    }
    return false;
};
